import {
  useMutation,
  type MutationState,
} from 'src/core/api/hooks/useMutation';

import { type IntegrationStatus } from '../../../integration/status';

export const useChooseSubsidiaryMutation = (): MutationState<{
  id: string;
}> => {
  return useMutation<{
    id: string;
  }>({
    request: {
      type: 'rest',
      method: 'put',
      target: 'companyAPI',
      endpoint: '/accounting-integration/subsidiaries/active',
    },
    options: {
      throwOnError: true,
      async onMutate({ client }): Promise<void> {
        client.cancelQueries('useIntegrationStatusQuery');

        const currentStatus = client.getQueryData<IntegrationStatus>(
          'useIntegrationStatusQuery',
        );

        if (
          !currentStatus ||
          currentStatus.integration === 'noIntegration' ||
          currentStatus.integration === 'switchInProgress'
        ) {
          return;
        }

        if (currentStatus.authorization.kind !== 'oauth1') {
          return;
        }

        client.setQueryData<IntegrationStatus>('useIntegrationStatusQuery', {
          ...currentStatus,
          authorization: {
            ...currentStatus.authorization,
            status: {
              status: 'connected',
            },
          },
        });
      },
      onSuccess({ client }): void {
        client.invalidateQueries(['useIntegrationStatusQuery']);
      },
    },
  });
};
